<h1>Products</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  <a
    mat-tab-link
    *ngFor="let link of links"
    (click)="gotoTab(link)"
    [active]="activeLink == link"
    >{{ link.title }}</a
  >
</nav>
<app-vendor-products-stripe-products
  *ngIf="activeLink.title === 'Stripe Products'"
></app-vendor-products-stripe-products>
<app-vendor-products-product-list
  *ngIf="activeLink.title === 'Vendor Products'"
></app-vendor-products-product-list>
<app-vendor-products-user-products
  *ngIf="activeLink.title === 'User Vendor Products'"
></app-vendor-products-user-products>
<app-vendor-products-webhooks
  *ngIf="activeLink.title === 'Vendor Webhook Events'"
></app-vendor-products-webhooks>
<app-vendor-products-api-log
  *ngIf="activeLink.title === 'Vendor API Log'"
></app-vendor-products-api-log>
<app-vendor-pending-transfers-page
  *ngIf="activeLink.title === 'Vendor Pending Transfers'"
></app-vendor-pending-transfers-page>
<app-vendor-completed-transfers-page
  *ngIf="activeLink.title === 'Vendor Completed Transfers'"
></app-vendor-completed-transfers-page>
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
